import { Editor } from 'slate';
import { getBlockAbove } from './get-block-above';
import { isAncestorEmpty } from './is-ancestor-empty';

export function isBlockAboveEmpty(editor: Editor, options?: Parameters<typeof getBlockAbove>[1]) {
    const block = getBlockAbove(editor, options)?.[0];
    if (!block) return false;
    return isAncestorEmpty(editor, block);
}
